import uniq from 'lodash-es/uniq';
import type { MetaArgs } from 'react-router';

/** @see https://remix.run/docs/en/main/route/meta#merging-with-parent-meta */
export const parentMeta = ({ matches }: MetaArgs) => {
  return uniq(matches.flatMap(({ meta }) => meta ?? []));
};
